import React from "react";
import "./FaceHeader.css";
const FaceHeader = () => {
  return (
    <div className="faceHeaderContainer">
      <h1>Face Waxing, De-tan & Threading in Bangalore at SCENT</h1>
      <p>
        In the vibrant city of Bangalore, maintaining smooth, radiant, and
        youthful skin can be challenging due to harsh environmental factors like
        sun exposure and pollution. At{" "}
        <a href="https://scentlifestyle.com/">SCENT</a>, we offer a
        comprehensive range of services designed to address these issues and
        help you achieve flawless skin. Our exclusive offerings include{" "}
        <a href="https://scentlifestyle.com/face-waxing-detan-threading-salon-in-bangalore">
          Face Waxing, De-tan, and Threading services
        </a>{" "}
        tailored to meet the unique needs of our clients. Here’s why SCENT
        should be your go-to destination for{" "}
        <a href="https://scentlifestyle.com/face-waxing-detan-threading-salon-in-bangalore">
          Face Waxing, De-tan, and Threading in Bangalore
        </a>{" "}
        .
      </p>
    </div>
  );
};

export default FaceHeader;
